<template>
  <div class="report-container">
    <div class="col-6">{{ totalCount }}</div>
    <div v-if="logReport && logReport.length > 0" class="report">
      <div
        v-for="(log, index) in logPresenters"
        :key="index"
        :class="{ header: index === 0 }"
        class="log-report-row"
      >
        <div class="report-cell">{{ log.adminName }}</div>
        <div class="report-cell multiline-text">{{ log.title }}</div>
        <div class="report-cell">{{ log.userAffectedName }}</div>
        <div class="report-cell">{{ log.createdAt }}</div>
      </div>
    </div>
    <div class="pagination mt-3">
      <div class="col-6 top-page">
        <el-pagination
          :total="total"
          :current-page="queryParams.page"
          :page-size="query.take"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { Pagination } from "element-ui";
import { toLocaleTH } from "@/lib/dateTime";
import { DateTime } from "luxon";

export default {
  components: {
    "el-pagination": Pagination,
  },
  props: {
    targetFeature: {
      type: String,
      required: true
    },
    activity: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      logReport: null,
      query: {
        page: 1,
        take: 30,
      },
      total: 0,
    };
  },
  computed: {
    logPresenters() {
      const header = {
        adminName: "ชื่อแอดมิน",
        title: "activity",
        userAffectedName: "ชื่อลูกค้า/ผู้ถูกผลกระทบ",
        createdAt: "วันที่บันทึก",
      };

      return [header, ...this.logReport];
    },
    queryParams() {
      const { page, take } = this.query;

      return {
        page: (page && +page) || 1,
        take,
      };
    },
    totalCount() {
      if (!this.total || this.total === 0) {
        return "ไม่พบข้อมูล";
      }

      const limit = this.query.take;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.logReport.length;

      const isLastPage = limit > currentTotalItem;
      const currentPage = this.query.page || 1;
      const end = (isLastPage ? total : currentPage * limit).toLocaleString();
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
  },
  watch: {
    async query() {
      await this.setupLogAdminByFeature();

      document.querySelector(".report-container").focus();
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.setupLogAdminByFeature();
  },
  methods: {
    async setupLogAdminByFeature() {
      await this.fetchReports();
    },
    async fetchReports() {
      const query = {
        ...this.queryParams,
        target_feature: this.targetFeature,
        activity: this.activity || null,
      };

      const logListByFeature =
        await baanRueJaiClient.admin.log.getListByFeature(query);

      this.logReport = logListByFeature.admin_activity_log_entities.map(
        (log) => ({
            adminName: log.admin_name,
            title: log.title,
            userAffectedName: log.user_affected_name,
            createdAt: toLocaleTH(DateTime.fromISO(log.created_at)).toFormat(
              "dd MMMM yyyy HH:mm"
            ),
          })
      );

      this.total = logListByFeature.count;
    },
    handleCurrentChange(page) {
      this.query = { ...this.query, page };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.report-container {
  padding: 20px 0;
  width: 100%;
}

.log-report-row {
  display: grid;
  // Fractional columns keep the original 200/550/250/200 proportions but
  // stretch the table to the page width, so it lines up with the form above.
  grid-template-columns: 2fr 5.5fr 2.5fr 2fr;
}

.log-report-row:first-child {
  position: sticky;
  top: 0;

  .report-cell {
    border-top: 1px solid #444;
    font-weight: bold;
    background: #ddd;
  }
}

.report-cell {
  padding: 10px;
  border-left: 1px solid rgb(206, 204, 204);
  border-bottom: 1px solid rgb(228, 225, 225);
  font-size: 14px;
}

// Cells only draw a left border, so the last column closes the table's right edge.
.report-cell:last-child {
  border-right: 1px solid rgb(206, 204, 204);
}

.report {
  padding: 15px;
}

.multiline-text {
  white-space: pre-line;
}
</style>